import { createApiHooks } from '@apis/next/common';
import { E2eMail } from '@models/next/Mail';

export const e2eMailApis = createApiHooks('/e2e/mail', [
  {
    method: 'get',
    path: '/',
    response: E2eMail.array(),
  },
]);
